export default {
  getGrainTypeLegend (item) {
    let legend = ''
    try {
      legend = item.name
      if (item.variety) {
        legend += ` (${item.variety.toLowerCase()})`
      }
    } catch (error) {
      console.error('[Method: getGrainTypeLegend]', error)
    }
    return legend
  }
}
